import { MouseEvent } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

const useGoBack = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const handleGoBack = (event: MouseEvent<HTMLAnchorElement>) => {
    if (location.key === 'default') return;
    event.preventDefault();
    navigate(-1);
  };

  return handleGoBack;
};

export default useGoBack;
